import { InternalElement } from "../lib/internal-element.js";
import { css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let PromotionalDescription = class extends InternalElement {
  render() {
    var _a;
    return html`
      <section id="promotional-description">
        <div>
          <slot></slot>
        </div>
        <div>${unsafeHTML(((_a = this.quote) == null ? void 0 : _a.product.promotional_description) || "")}</div>
      </section>
    `;
  }
};
PromotionalDescription.styles = css`
    /* PROMOTIONAL DESCRIPTION STYLES */ 
    #promotional-description {
      font-family: var(--default-vi-promotional-description-font-family);
      font-size: var(--default-vi-promotional-description-font-size);
      font-weight: var(--default-vi-promotional-description-font-weight);
      color: var(--default-vi-promotional-description-color);
    }
  
    #promotional-description * {
      margin: 0;
    }
  
    #promotional-description h1, 
    #promotional-description h2, 
    #promotional-description h3, 
    #promotional-description h4 {
      display: flex;
      align-items: center;
    }
  
    @container (max-width: 800px) {
      #promotional-description h3 {
        display: flex;
        flex-direction: row;
      }
    }

    @media (max-width: 800px) {
      #promotional-description h3 {
        display: flex;
        flex-direction: row;
      }
    }
  
    #promotional-description span.tag {
      margin: 0;
      margin-left: 5px;
      padding: 2px 6px;
      line-height: 20px;
  
      font-family: var(--default-vi-font-family);
      font-size: 0.85rem;
      font-weight: 400;
      border-radius: 5px;
      border-radius: var(--default-vi-border-radius);
  
      background-color: var(--default-vi-secondary-color);
      color: var(--default-vi-secondary-contrast-color);
    }

    div ::slotted(*) {
      float: right;
      margin-left: 10px;
      margin-bottom: 5px;
    }

    @container (max-width: 700px) {
      div ::slotted(*) {
        float: unset;
        flex-direction: column;
      }
    }

    @media (max-width: 700px) {
      div ::slotted(*) {
        float: unset;
        flex-direction: column;
      }
    }
  `;
PromotionalDescription = __decorateClass([
  customElement("promotional-description")
], PromotionalDescription);
export {
  PromotionalDescription
};
